import * as React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { HERO_ACTIONS } from 'constants/heroImages';
import { paramsFromListSearch, useActionTotals } from 'app/hooks/useActionTotals';
import PageHero from '~components/PageHero';
import Breadcrumb, { BreadcrumbItem } from '~components/Breadcrumb';
import StatsSummary from '~components/StatsSummary';
import MapToggle from '~components/MapToggle';
import styles from './styles.module.scss';

interface Props {
  title: string;
  /** Shown above the title (e.g. on a territory's page); omitted on top-level lists. */
  breadcrumb?: BreadcrumbItem[];
  /** The list's map, relative or absolute; the current filters go along. No button without it. */
  mapPath?: string | null;
  children: React.ReactNode;
}

/**
 * The redesigned list page: a photo header with the title, the totals of the current filters
 * (and territory, on a territory's page) and the map button, then the list.
 */
const ListPageLayout = ({ title, breadcrumb, mapPath, children }: Props) => {
  const location = useLocation();
  const { id } = useParams();
  // A territory's page fixes the Territorio; elsewhere it comes from the list's own filter.
  const totals = useActionTotals({ ...paramsFromListSearch(location.search), ...(id ? { territory: id } : {}) });

  return (
    <div className={styles.page}>
      <PageHero
        variant="image"
        image={HERO_ACTIONS}
        height={215}
        breadcrumb={breadcrumb && <Breadcrumb items={breadcrumb} />}
        title={title}
        aside={<StatsSummary variant="card" totals={totals} />}
        action={mapPath ? <MapToggle defaultChecked={false} listPath={`${mapPath}${location.search}`} /> : undefined}
      />
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default ListPageLayout;
